import React from 'react';
import ReactDOM from 'react-dom';
import { Query } from '@apollo/client/react/components';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { mapAfter } from 'apollo-relay/update-query';

import Modal from 'four-nets/ui-v2/modal/modal';
import LoadingWrapperView from 'four-nets/ui/loaders/loading-wrapper-view';
import FetchMore from 'four-nets/ui-v2/fetch-more-button/fetch-more-button';
import LikersList from 'four-nets/photoblog/posts/common/likers-list/likers-list';

import query, { ImageLikersQuery, ImageLikersQueryVariables } from './image-likers-loader.graphql';

export interface Props {
    id: string;
    open: boolean;
    onClose: () => any;
}

interface State {
    loading?: boolean;
    render?: boolean;
}

class ImageLikersDialog extends React.PureComponent<Props, State> {
    state = { loading: false };

    render() {
        const { id, open, onClose } = this.props;

        return (
            <Modal title={<FormattedMessage id='LIKE' />} open={open} onClose={onClose}>
                <Query<ImageLikersQuery, ImageLikersQueryVariables>
                    query={query}
                    variables={{ imageId: id }}
                    fetchPolicy='cache-first'
                >
                    {({ data, loading, fetchMore }) => {
                        return (
                            <LoadingWrapperView loading={loading}>
                                {data && data.image && data.image.likers ? <LikersList {...data.image} /> : null}
                                {data && data.image && data.image.likers && data.image.likers.pageInfo.hasNextPage ? (
                                    <FetchMore
                                        disabled={this.state.loading}
                                        loading={this.state.loading}
                                        onClick={() => {
                                            this.setState({ loading: true });
                                            const endCursor =
                                                data &&
                                                data.image &&
                                                data.image.likers &&
                                                data.image.likers.pageInfo.endCursor;

                                            fetchMore({
                                                variables: { endCursor },
                                                updateQuery: (
                                                    previousResult = {} as ImageLikersQuery,
                                                    { fetchMoreResult = {} as ImageLikersQuery }
                                                ) => {
                                                    return {
                                                        ...previousResult,
                                                        ...fetchMoreResult,
                                                        image: {
                                                            ...(previousResult && previousResult.image),
                                                            ...(fetchMoreResult && previousResult.image),
                                                            likers: mapAfter(
                                                                previousResult.image && previousResult.image.likers,
                                                                fetchMoreResult.image && fetchMoreResult.image.likers
                                                            ),
                                                        },
                                                    } as ImageLikersQuery;
                                                },
                                            }).then(() => {
                                                this.setState({ loading: false });
                                            });
                                        }}
                                    />
                                ) : null}
                            </LoadingWrapperView>
                        );
                    }}
                </Query>
            </Modal>
        );
    }
}

export default Styled({})(ImageLikersDialog);
